import { getSafeURI } from '@/utils/helpers';

type StrObj = Record<string, string>;
type StrTpl = [string, string];
const URITuplesIntoObj = (obj: StrObj, [k, v]: StrTpl) => ({ ...obj, [k]: getSafeURI(v) });

export const resolveURIObject = (URIs: StrObj) => Object.entries(URIs).reduce(URITuplesIntoObj, {});

export const resolveURIList = ({ rawVal }: { rawVal: StrObj }) => resolveURIObject(rawVal);
